import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { removeFromQuery } from '../../helpers';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import { deleteInterest } from '../actions';

const dialogContentStyle = {
    width: '90%',
    maxWidth: 'none'
};

const raisedButtonStyle = {
    marginRight: '10px'
};

const onClose = () => {
    removeFromQuery('deleteInterestId');
};

const DeleteDialog = ({ open = false, interestId, interestName = '', deleteInterest = () => {} }) => (
    <Dialog
        open={open}
        dialogContentStyle={dialogContentStyle}
        title={`Delete interest ${interestName}?`}
        autoScrollBodyContent
        repositionOnUpdate
        autoDetectWindowHeight
        onRequestClose={onClose}
        modal={false}
    >
        <RaisedButton
            primary
            label="Submit"
            onClick={() => {
                deleteInterest(interestId);
                onClose();
            }}
            style={raisedButtonStyle}
        />
        <RaisedButton onClick={onClose} secondary label="Cancel" />
    </Dialog>
);

DeleteDialog.propTypes = {
    open: PropTypes.bool,
    interestId: PropTypes.string,
    interestName: PropTypes.string,
    deleteInterest: PropTypes.func
};

export default connect(
    ({ routing, requery = { entities: {} } }) => {
        const interestId = routing.location && routing.location.query && routing.location.query.deleteInterestId;
        const interestName =
            requery.entities.userInterests &&
            requery.entities.userInterests[interestId] &&
            requery.entities.userInterests[interestId].name;

        return {
            open: Boolean(interestId),
            interestId,
            interestName
        };
    },
    { deleteInterest }
)(DeleteDialog);



/** WEBPACK FOOTER **
 ** ../src/dash/front/interests-page/components/DeleteDialog.js
 **/